import { ChirpError } from 'rpc-client-utils';
import { ErrorSubCategory } from '../constants/errorSubCategory';
import type { ApprovalError } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc';

// rpc-client-utils spreads errorType onto ChirpError at runtime but doesn't
// reflect it in the class type definition.
interface ChirpRpcError extends ChirpError {
  errorType?: string;
}

const CHIRP_ERROR_TO_SUBCATEGORY: Partial<
  Record<ApprovalError, ErrorSubCategory>
> = {
  APPROVAL_ALREADY_EXISTS: ErrorSubCategory.ACTIVE_APPROVAL_ALREADY_EXISTS,
  TRANSITION_NOT_PERMITTED: ErrorSubCategory.APPROVAL_TRANSITION_NOT_PERMITTED,
  NOT_AUTHORIZED: ErrorSubCategory.USER_IS_NOT_AN_APPROVER,
  APPROVER_INVALID: ErrorSubCategory.APPROVER_NOT_VALID,
  APPROVALS_NOT_ENABLED: ErrorSubCategory.APPROVALS_NOT_ENABLED,
};

const findChirpError = (error: unknown, depth = 0): ChirpError | undefined => {
  if (depth > 4 || !error || typeof error !== 'object') return undefined;
  if (error instanceof ChirpError) return error;
  if ('cause' in error) {
    return findChirpError((error as { cause: unknown }).cause, depth + 1);
  }
  return undefined;
};

export const getErrorSubCategoryFromError = (
  error: unknown
): ErrorSubCategory => {
  const chirpError = findChirpError(error);
  if (chirpError) {
    const { errorType } = chirpError as ChirpRpcError;
    if (errorType) {
      return (
        CHIRP_ERROR_TO_SUBCATEGORY[errorType as ApprovalError] ??
        ErrorSubCategory.UNKNOWN_ERROR
      );
    }
  }

  return ErrorSubCategory.UNKNOWN_ERROR;
};
